// extracted by mini-css-extract-plugin
export const signupGroup = "g_c";
export const inputEmail = "g_n";
export const inputPassword = "g_D";
export const txtForgetPassword = "g_F";
export const btnLogin = "g_G";
export const txtNoaccount = "g_H";
export const txtSignup = "g_J";
export const errorMsg = "g_m";